import { ItemZoneContextType } from '@context/ItemZoneContext'
import { AnyID, Textures } from '@types'
import { ProjectActions } from '../../../store/projectActions'

export async function handlePasteAll(
  ctx: ItemZoneContextType,
  editZone: ProjectActions['editZone'],
) {
  if (!ctx.object.current) return
  const obj = ctx.object.current
  const id = obj.id as AnyID // TODO check? am dumb
  const currTexture = ctx.currentTexture

  if (!currTexture) return
  obj.textures.forEach((property: Textures[number]) => {
    editZone(id, property.zoneName, obj.zones[currTexture.zoneName].material)
  })

  ctx.setCopiedIconId(null)
  const pasteIcons = ctx.pasteIcons
  if (!pasteIcons) return
  ctx.setPasteIcons(
    Object.fromEntries(Object.entries(pasteIcons).map(([key]) => [key, 'cantPaste'])),
  )
  // TODO: may not be needed
  ctx.setCurrentTexture((prev: Textures[number]) => {
    return {
      ...prev,
      searchID: currTexture.searchID,
      id: currTexture.id,
      name: currTexture.name,
      url: currTexture.url,
      groupID: currTexture.groupID,
    }
  })
}
